export default "__VITE_ASSET__B4pfJNb5__"